export default () => {

  const $socialShare = $('.aauw-social-share-inner');

  if ($socialShare.length) {
    const isSticky = $socialShare.isSticky({
      breakpoint: 1400,
      id: 'aauw-social-share-inner-placeholder',
      class: 'aauw-social-share-inner-placeholder',
      stopper: 'footer',
      stuckClass: '-stuck'
    });
    isSticky.init();
  }

  $('.js-social-share').on('click', (e) => {
    e.preventDefault();

    const url = $(e.currentTarget).attr('href');
    const top = (screen.height / 3) - 150;
    const left = (screen.width / 2) - 250;

    // Calculate the position of the popup so it’s centered on the screen.
    window.open(
      url,
      '',
      'menubar=no,toolbar=no,resizable=yes,scrollbars=yes,width=500,height=300,top=' + top + ',left=' + left
    );
  });

};
